import 'babel-polyfill';
import Es6Promise from 'es6-promise'
Es6Promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import '@/plugins/comm.less';

import $ from 'jquery';

import 'lib-flexible';
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios';
import store from './store';
// import tabstore from './tabStore/tabbarStore.js';
import infiniteScroll from 'vue-infinite-scroll';

import WebApp from '@/utils/webapp.js';


Vue.use(infiniteScroll)

Vue.prototype.$axios = axios;

if (JSON.parse(localStorage.getItem('userInfo')) != null) {
	axios.defaults.headers = {
		"token": JSON.parse(localStorage.getItem('userInfo')).token,
		"content-type": 'application/json; charset=utf-8',
	}
}else {
	localStorage.setItem('userInfo',null);
}

import appConfig from './router';

import Api from '@/utils/api.js';

//图片懒加载
import {
	Lazyload
} from 'vant';
Vue.use(Lazyload);



// 轮播
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import style
import 'swiper/css/swiper.css';

Vue.use(Vant);
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

const router = appConfig.router;

Vue.prototype.$api = Api;

Vue.prototype.localStorage = localStorage;

//简繁体切换
import zh_tran from './assets/js/traditional'; 
Vue.prototype.$zh_tran = zh_tran;

//全局注册loading组件
import Loading from './components/Loading.vue'  //loading
Vue.component('Loading', Loading);

Vue.prototype.$webapp = WebApp;
new Vue({
	router,
	store,
	// tabstore,
	render: h => h(App),
}).$mount('#app')
